import React from 'react'
import moment from 'moment'
import { Input, Button, Select } from 'semantic-ui-react'

export default class DateFields extends React.PureComponent {
  formatStartFrom = value =>
    Number(
      moment(value)
        .startOf('day')
        .format('x')
    )

  formatEndAt = value =>
    Number(
      moment(value)
        .endOf('day')
        .format('x')
    )

  render() {
    const { loading, onSearch, onFieldChange, merchants, merchantKey } = this.props
    let { startFrom, endAt } = this.props

    startFrom = moment(startFrom).format('YYYY-MM-DD')
    endAt = moment(endAt).format('YYYY-MM-DD')
    return (
      <div style={{ display: 'inline-block' }}>
        <div className="capitalize" style={{ display: 'inline-block', marginLeft: 10, marginRight: 10 }}>
          Merchant
        </div>
        <Select
          style={{ display: 'inline-block', marginLeft: 10, marginRight: 10 }}
          search
          required
          loading={loading}
          options={merchants}
          placeholder="Select Merchant"
          value={merchantKey}
          onChange={(e, { value }) => {
            onFieldChange('merchantKey', value)
          }}
        />
        <div className="capitalize" style={{ display: 'inline-block', marginRight: 10 }}>
          From
        </div>

        <Input
          type="date"
          name="from"
          value={startFrom}
          onChange={e => onFieldChange('startFrom', this.formatStartFrom(e.target.value))}
        />

        <div className="capitalize" style={{ display: 'inline-block', marginLeft: 10, marginRight: 10 }}>
          To
        </div>

        <Input
          type="date"
          name="to"
          value={endAt}
          onChange={e => onFieldChange('endAt', this.formatEndAt(e.target.value))}
        />
        <Button disabled={loading} onClick={onSearch} style={{ marginLeft: 10 }}>
          Search
        </Button>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/reports/fields/dateRangeSearchField.js